import React from 'react';
import { Icon } from './Icon.js';
export const IconSquarePlayFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.75.5H3.25C1.733.5.5,1.733.5,3.25v5.5c0,1.517,1.233,2.75,2.75,2.75h5.5c1.517,0,2.75-1.233,2.75-2.75V3.25c0-1.517-1.233-2.75-2.75-2.75Zm-1.026,6.018l-2.308,1.385c-.403.242-.916-.048-.916-.518v-2.771c0-.47.513-.76.916-.518l2.308,1.385c.391.235.391.802,0,1.037Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconSquarePlayFill12.js.map